import { Downloads } from './components/Downloads';
import { Uploads } from './components/Uploads';
import { selectAppStep } from './store/features/context/selectors';
import { AppSteps } from './api/api.type';
import AppComponent from 'Views/AppComponent';
import { useAppSelector } from 'store/hooks';
import { NoLicence } from 'components/NoLicence';

const App = () => {
    const step = useAppSelector(selectAppStep);

    if (step === AppSteps.EDIT) return <AppComponent />;
    if (step === AppSteps.DOWNLOAD) return <Downloads />;
    if (step === AppSteps.UPLAOD) return <Uploads />;
    if (step === AppSteps.NOLICENCE) return <NoLicence />;

    return null;
};
export default App;
